'use strict';

/* eslint-disable no-undef */

const pdpTracking = {
    selectors: {
        trackablePdpElements: '[data-event-interaction]',
        shadefinderButton: '.js-button-sf',
        vtoButton: '.js-button-vto'
    },

    init() {
        this.initEvents();
    },

    initEvents() {
        // $(this.selectors.trackablePdpElements).on('click', this.handlePdpElementClick.bind(this));
        $(this.selectors.shadefinderButton).on('click', this.shadefinderButtonClick.bind(this));
        $(this.selectors.vtoButton).on('click', this.vtoButtonClick.bind(this));
    },

    // handlePdpElementClick(e) {
    //     const $currentTarget = $(e.currentTarget);

    //     window.dataLayer.push({
    //         'event': 'product_page_interaction',
    //         'interactionType': $currentTarget.data('event-interaction')
    //     });
    // },

    shadefinderButtonClick() {
        window.dataLayer.push({
            'sf_type': 'product page',
            'event':'shade_finder_click',
            'sf_product_name': pidData.name
        });
    },

    vtoButtonClick() {
        window.dataLayer.push({
            'button_type': 'product page',
            'color_name': $('.variation-selector__button #current-color').attr('data-shade-color'),
            'vto_name' : pidData.name,
            'vto_site' : $('.gtmsite').attr('data-site'),
            'event':'virtual_try_on'
        });
    }
};

pdpTracking.init();